import { useLanguage } from "../../contexts/LanguageContext";
import { getTranslation } from "../../translations";
import useFadeIn from "../../hooks/useFadeIn";
import "../../hooks/useFadeIn.css";
import "./AllexHero.css";

function AllexHero() {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const descFade = useFadeIn({ delay: 200 });
  const imgFade = useFadeIn({ delay: 400 });
  const feat1Fade = useFadeIn({ delay: 600 });
  const feat2Fade = useFadeIn({ delay: 800 });
  const feat3Fade = useFadeIn({ delay: 1000 });
  const feat4Fade = useFadeIn({ delay: 1200 });

  const featureFades = [feat1Fade, feat2Fade, feat3Fade, feat4Fade];

  const features = [
    {
      number: "1",
      title: t("allexHero.feature1Title"),
      description: t("allexHero.feature1Desc"),
    },
    {
      number: "2",
      title: t("allexHero.feature2Title"),
      description: t("allexHero.feature2Desc"),
    },
    {
      number: "3",
      title: t("allexHero.feature3Title"),
      description: t("allexHero.feature3Desc"),
    },
    {
      number: "4",
      title: t("allexHero.feature4Title"),
      description: t("allexHero.feature4Desc"),
    },
  ];

  const subtitleLines = t("allexHero.subtitle").split("\n");

  return (
    <section className="allex-hero">
      <div className="allex-hero-container">
        <div className="allex-hero-content">
          <h1 className="allex-hero-title">ALLEX</h1>
          <p className="allex-hero-subtitle">
            {subtitleLines.map((line, index) => (
              <span key={index}>
                {line.split(/(ALL EX)/g).map((part, i) =>
                  part === "ALL EX" ? (
                    <strong key={i} style={{ fontWeight: "700" }}>
                      ALL EX
                    </strong>
                  ) : (
                    part
                  )
                )}
                {index < subtitleLines.length - 1 && <br />}
              </span>
            ))}
          </p>
          <p
            ref={descFade.ref}
            className={`allex-hero-description fade-in-element ${descFade.isVisible ? 'visible' : ''}`}
          >
            {t("allexHero.description")}
          </p>
          <div className="allex-hero-features">
            {features.map((feature, index) => {
              const fade = featureFades[index];
              return (
                <div
                  key={feature.number}
                  ref={fade.ref}
                  className={`allex-hero-feature fade-in-element ${fade.isVisible ? 'visible' : ''}`}
                >
                  <span className="allex-hero-feature-number">
                    {feature.number}
                  </span>
                  <div className="allex-hero-feature-text">
                    <span className="allex-hero-feature-title">
                      {feature.title}{" "}
                    </span>
                    <span className="allex-hero-feature-desc">
                      {feature.description}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div
          ref={imgFade.ref}
          className={`allex-hero-image-wrapper fade-in-element ${imgFade.isVisible ? 'visible' : ''}`}
        >
          <img
            className="allex-hero-image"
            src="/images/allex_hero.png"
            alt="ALLEX Robot"
          />
        </div>
      </div>
    </section>
  );
}

export default AllexHero;
